import { render } from "./StockCalcHelp.vue?vue&type=template&id=e77a0460&scoped=true"
import script from "./StockCalcHelp.vue?vue&type=script&lang=js"
export * from "./StockCalcHelp.vue?vue&type=script&lang=js"

import "./StockCalcHelp.vue?vue&type=style&index=0&id=e77a0460&scoped=true&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e77a0460"]])

export default __exports__